import React, { 
  useEffect, 
  useMemo, 
  useState 
} from "react";
import { 
  useDispatch, 
  connect, 
  useSelector 
} from "react-redux";
import MetaTags from "react-meta-tags";
import { fetchDictionaryStart } from "store/dictionary/actions";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import Deposits from "pages/Transactions/Crypto/Deposit";
import DepositsForex from "pages/Transactions/Forex/deposits/DepositForex";
import { useTranslation } from "react-i18next";
function DepositsIndex() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { profileMetaInfo = {} } = useSelector((state) => state.Profile);
  useEffect(() => {
    dispatch(fetchDictionaryStart());
  }, [dispatch]);
  const tabs = useMemo(() => {
    const {
      transactions: { depositDetails: { forex } = {} } = {},
    } = profileMetaInfo;
    const allTabs = [
      {
        tabId: "1",
        navLinkName: t("Wallets"),
        component: <Deposits t={t} />,
        hidden: !forex,
      },
      {
        tabId: "2",
        navLinkName: t("Forex"),
        component: <DepositsForex t={t} />,
        hidden: !forex,
      },
    ];
    return allTabs.filter((item) => !item.hidden);
  }, [profileMetaInfo, t]);

  const [activeTab, setactiveTab] = useState(
    tabs.length > 0 ? tabs[0].tabId : ""
  );

  useEffect(() => {
    if (tabs.length > 0) {
      setactiveTab(tabs[0].tabId);
    } else {
      setactiveTab("");
    }
  }, [tabs]);

  const toggle = (tab) => {
    if (activeTab !== tab) setactiveTab(tab);
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Deposits</title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>{t("Deposits")}</h2>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Nav tabs>
                    {tabs.map((tabItem) => (
                      <NavItem key={tabItem.tabId}>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: activeTab === tabItem.tabId,
                          })}
                          onClick={() => toggle(tabItem.tabId)}
                        >
                          {tabItem.navLinkName}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    {tabs.map((tabItem) => (
                      <TabPane key={tabItem.tabId} tabId={tabItem.tabId}>
                        <Row>
                          <Col sm="12">{tabItem.component}</Col>
                        </Row>
                      </TabPane>
                    ))}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => ({
  loading: state.dictionaryReducer.loading || false,
  dictionary: state.dictionaryReducer.dictionary || [],
  error: state.dictionaryReducer.error,
});
export default connect(mapStateToProps, null)(DepositsIndex);
